import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {LocalStorageService} from "../../core/services/local-storage.service";

@Directive({
  selector: '[custom-select]'
})
export class CustomSelectDirective {
  @Input() labelId: string

  constructor(private el: ElementRef, private storageService: LocalStorageService) {
  }

  @HostListener('nzOpenChange', ['$event']) nzOpenChange(event) {
    this.addFloatingLabel_(event)
  }

  @HostListener('ngModelChange', ['$event']) ngModelChange(event) {
    if (event) {
      this.storageService.save(`${this.labelId}`, `${this.labelId}`);
    } else {
      this.storageService.deleteValue(`${this.labelId}`);
    }
    this.addFloatingLabel(event);
  }

  addFloatingLabel_(event) {
    const alreadyOpen = this.storageService.get(`${this.labelId}`);
    let element = document.getElementById(`${this.labelId}`)
    if (event) {
      element.className = 'select-float-label';
    } else if (alreadyOpen) {
      element.className = 'select-float-label';
    } else {
      element.className = 'select-label';
    }
  }

  addFloatingLabel(event) {
    const fieldValue = this.el?.nativeElement?.innerText;
    let element = document.getElementById(`${this.labelId}`)
    if (event) {
      element.className = 'select-float-label';
      this.el.nativeElement.classList?.remove('custom-input-error');
    } else if (fieldValue && event) {
      element.className = 'select-float-label';
      this.el.nativeElement.classList?.remove('custom-input-error');
    } else {
      element.className = 'select-label';
      this.el.nativeElement.classList.add('custom-input-error');
    }
  }
}

